import { render, staticRenderFns } from "./invoice-items.vue?vue&type=template&id=4b06d426&"
import script from "./invoice-items.vue?vue&type=script&lang=js&"
export * from "./invoice-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports